var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8655 4.76888L8.49938 9.22437L1.13309 4.76858L8.49883 1.04277L15.8655 4.76888Z",
    stroke: "#555555",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9289 7.52343L8.49912 12.0189L1.07057 7.52343C0.714945 7.3082 0.27459 7.4609 0.0861024 7.86352C-0.103706 8.26595 0.0309205 8.76529 0.385559 8.97995L8.15708 13.6822C8.26425 13.747 8.38171 13.7792 8.49951 13.7792C8.6179 13.7792 8.7352 13.7474 8.84254 13.6822L16.6144 8.97995C16.9683 8.76529 17.1027 8.26595 16.914 7.86352C16.7241 7.46084 16.2834 7.30814 15.9289 7.52343Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9289 10.7423L8.49912 15.2362L1.07057 10.7423C0.714945 10.5269 0.27459 10.6797 0.0861024 11.0818C-0.103706 11.4842 0.0309205 11.9841 0.385559 12.1984L8.15708 16.8991C8.26425 16.9644 8.38171 16.9966 8.49951 16.9966C8.6179 16.9966 8.7352 16.9648 8.84254 16.8991L16.6144 12.1984C16.9683 11.9841 17.1027 11.4843 16.914 11.0818C16.7241 10.6797 16.284 10.5268 15.9289 10.7423Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemGrey);
export default __webpack_public_path__ + "static/media/item-grey.3cef02182c9cc7c560497ab9dc882e61.svg";
export { ForwardRef as ReactComponent };